var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-card md-card-nav-tabs"},[_c('div',{staticClass:"md-card-content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }